// Shared bits for the Attendance tabs (Mercedes, Nov 3, 2026).
import React from 'react';

export const CODE_STYLE = {
  P: ['#e8f5ec', '#1c7c43'],
  C: ['#fdeaea', '#b42318'],
  U: ['#fbe4f0', '#9d174d'],
  H: ['#eef0f2', '#374151'],
  S: ['#fdf3e2', '#8a5a00'],
  V: ['#e7f0fb', '#1d4f91'],
  E: ['#ffedd5', '#9a3412'],
  L: ['#ffedd5', '#9a3412'],
  F: ['#f1ebfb', '#5b3a99'],
  O: ['#eef0f2', '#374151'],
  OFF: ['#f3f4f6', '#6b7280'],
  N: ['#fff6e0', '#8a5a00'],
};

export const th = { textAlign: 'right', padding: '6px 8px', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.3px', color: 'var(--gray-500, #6b7280)', whiteSpace: 'nowrap', verticalAlign: 'bottom' };
export const td = { textAlign: 'right', padding: '6px 8px', fontSize: 13, whiteSpace: 'nowrap' };
export const left = { textAlign: 'left' };
export const box = { border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', overflowX: 'auto' };
export const btn = { background: 'var(--navy, #00395C)', color: '#fff', border: 0, borderRadius: 6, padding: '7px 12px', fontWeight: 600, cursor: 'pointer' };
export const btn2 = { background: '#fff', color: 'var(--navy, #00395C)', border: '1px solid #c5d0da', borderRadius: 6, padding: '6px 11px', fontWeight: 600, cursor: 'pointer' };
export const input = { border: '1px solid #c5d0da', borderRadius: 5, padding: '5px 7px', fontSize: 13 };
export const lbl = { display: 'flex', flexDirection: 'column', gap: 3, fontSize: 12, color: 'var(--gray-600, #4b5563)' };
export const muted = { fontSize: 12, color: '#6b7280' };

export const todayEt = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());
export const addDays = (ymd, n) => new Date(Date.parse(ymd + 'T00:00:00Z') + n * 864e5).toISOString().slice(0, 10);
export const dow = (ymd) => new Date(ymd + 'T00:00:00Z').getUTCDay();
export const monday = (ymd) => addDays(ymd, -((dow(ymd) + 6) % 7));
const asDate = (ymd) => { const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number); return new Date(y, m - 1, d); };
export const fmtDay = (ymd) => (ymd ? asDate(ymd).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '');
export const fmtShort = (ymd) => asDate(ymd).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
export const fmtDow = (ymd) => asDate(ymd).toLocaleDateString('en-US', { weekday: 'short' });
export const fmtMd = (ymd) => asDate(ymd).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric' });
export const fmtWhen = (ts) => (ts ? new Date(ts).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');
export const clock = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
};
export const clockShort = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  return `${((h + 11) % 12) + 1}${m ? ':' + String(m).padStart(2, '0') : ''}`;
};
export const pts = (n) => (Number(n) % 1 ? Number(n).toFixed(1) : String(Number(n) || 0));

export function Code({ code, small, title }) {
  if (!code) return null;
  const s = CODE_STYLE[code] || ['#eef0f2', '#374151'];
  return (
    <span title={title} style={{ background: s[0], color: s[1], borderRadius: 4, padding: small ? '0 4px' : '1px 6px', fontWeight: 700, fontSize: small ? 11 : 12, display: 'inline-block', minWidth: small ? 18 : 22, textAlign: 'center' }}>
      {code}
    </span>
  );
}

export function Msg({ err, ok }) {
  if (err) return <div style={{ background: '#fdeaea', color: '#b42318', padding: '8px 11px', borderRadius: 6, marginBottom: 10 }}>{err}</div>;
  if (ok) return <div style={{ background: '#e8f5ec', color: '#1c7c43', padding: '8px 11px', borderRadius: 6, marginBottom: 10 }}>{ok}</div>;
  return null;
}
